module.exports = "/images/exclamation-sign.svg?1538a3b19f24e1f40e367d13a234fc87";